import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";

interface Props {
  question: string;
  answer: string;
}

function FAQ(props: Props) {
  const { answer, question } = props;

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel2-content"
        id="panel2-header"
      >
        <Typography
          style={{ fontWeight: "bolder", textAlign: "left", fontSize: 12 }}
        >
          {question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography
          style={{ fontWeight: "bolder", textAlign: "left", fontSize: 12 }}
        >
          {answer}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}

export default FAQ;
